// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2xfNT","header":"ReportDetails_header__MiWVM","title":"ReportDetails_title__H0d9H","left":"ReportDetails_left__1n2wb"};